// extracted by mini-css-extract-plugin
export default {"pdTopVideo":"index_pdTopVideo__HOq33"};